import { useMemoizedFn } from "ahooks";
import { useEffect, useMemo, useRef, useState } from "react";
import { type IPinActionsProps } from "./index";

export function usePinActionsWithCard(needHoldPinAction?: boolean) {
  const [pinActionsProps, setPinActionsProps] = useState<
    Partial<IPinActionsProps>
  >({});

  const hoverRef = useRef<boolean>(false);

  /**
   * 鼠标进入卡片
   * 获取卡片图片dom的位置信息与宽高、offsetParent，用于定位操作按钮
   * pin: 当前卡片的采集信息，用于采集按钮操作
   */
  const onMouseEnterCard = useMemoizedFn(({ pin, imageDom, onUpdatePin }) => {
    if (hoverRef.current) {
      return;
    }

    hoverRef.current = true;
    setPinActionsProps({
      pin,
      position: {
        x: imageDom.offsetLeft,
        y: imageDom.offsetTop,
      },
      width: imageDom.offsetWidth,
      height: imageDom.offsetHeight,
      onUpdatePin,
      offsetParent: imageDom.offsetParent,
    });
  });

  const onMouseLeaveCard = useMemoizedFn(() => {
    hoverRef.current = false;

    // 如果需要保持住采集操作，则不进行隐藏
    if (needHoldPinAction && holdPinAction) {
      return;
    }
    setPinActionsProps({});
  });

  const [holdPinAction, setHoldPinAction] = useState(false);
  const contextValue = useMemo(
    () => ({
      holdPinAction,
      setHoldPinAction,
    }),
    [holdPinAction]
  );

  useEffect(() => {
    // 如果鼠标离开卡片，并且不需要保持住采集操作，则隐藏
    if (!hoverRef.current && !holdPinAction) {
      setPinActionsProps({});
    }
  }, [holdPinAction]);

  return {
    pinActionsProps,
    onMouseEnterCard,
    onMouseLeaveCard,
    contextValue,
  };
}
